module.exports = __webpack_public_path__ + "media/fonts/Inter-SemiBold-bfb220b7f35f45b33defe87e89dad9df.woff";